<template>
    <div>
        <div class="app-main__inner">
            <TituloComponente icono-titulo="fas fa-clipboard-list" texto-titulo="Liquidacion"  :to-create-action="{name:'NuevaLiquidacion'}" to-create-text="Nueva Liquidacion"/>
            <div class="tab-content">
                <div class="tab-pane tabs-animation fade show active" id="tab-content-0" role="tabpanel">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="main-card mb-3 card">
                                <div class="card-body">
                                    <h5 class="card-title">Listado de liquidaciones</h5>
                                     <DataList ref="datatable" url="/liquidacion" :fields="fields" :rowClick="verLiquidacion" :toDate="toDate"></DataList>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>                               
        </div>
    </div>
</template>
<script>
import TituloComponente from '@/components/layouts/TituloComponente';
import DataList from '@/components/layouts/DataList';
export default {
    name: "ListarLiquidaciones",
    components: {
        TituloComponente,
        DataList,
    },
    data(){
        return{
            liquidacion: [],
            fields: [
                {
                name: "periodo",
                label: "",
                type: "title",
                class: "text-primary"
                },
                {
                name: "tipo_liquidacion",
                label: "",
                type: "title",
                class: "text-primary",
                prepend: '-'
                },
                {
                name: "created_at",
                label: "Fecha",
                type: "field",
                class: "text-alternate",
                }
            ],
            toDate: ['created_at']
        }
    },
    created(){
    },
    mounted(){

    },
    methods:{
        verLiquidacion(liquidacion){
            //alert(liquidacion.id);
            this.$router.push({name:"VerLiquidacion", params:{id:liquidacion.id}})
        }
    },
}
</script>
